<template>
    <div :class="$style.container"
         id="loading"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)">
        <el-container>
            <div  id="collectionHome">
                <div :class="$style.left">
                    <el-row>
                        <el-col>
                            <div style="padding-top: 8px;margin-bottom:30px;font-weight: bold;">客户数据采集</div>
                        </el-col>
                    </el-row>


                </div>
                <div style="width: 100%;margin-top:30px;">
                    <el-form>
                        <el-row>
                            <el-col :span="24" style="position: relative;margin-top: 30px">
                                <span  style="font-weight: bold;margin-right: 10px;display: inline-block;width: 70px">采集对象</span>
                                <el-checkbox-group v-model="channelCheckList" style="display: inline-block">
                                    <el-checkbox label="INSTITUTION" style="color: #606266;" v-if="clientObj.showInstitution">机构</el-checkbox>
                                    <el-checkbox label="HCP" style="color: #606266;" v-if="clientObj.showInstitution">HCP</el-checkbox>
                                    <el-checkbox label="RETAILSTORE" style="color: #606266;" v-if="clientObj.showStore">门店</el-checkbox>
                                    <el-checkbox label="DISTRIBUTOR" style="color: #606266;" v-if="clientObj.showDistributor">经销商</el-checkbox>
                                    <el-checkbox label="CUSTOMTABLE" style="color: #606266;">自定义表格</el-checkbox>
                                </el-checkbox-group>
                            </el-col>
                            <el-col :span="12" style="text-align: left;margin-top:20px;">
                                <span  style="font-weight: bold;display: inline-block;width: 70px">任务名称</span>
                                <el-input type="text" v-model="task_name" placeholder="请输入采集任务名称"
                                          style="width: calc(100% - 90px)" >
                                </el-input>
                            </el-col>
                            <el-col :span="12" style="text-align: left;margin-top:20px;">
                                <span  style="font-weight: bold;display: inline-block;width: 70px">采集日期
                                        </span>
                                <div style="display: inline-block;width: calc(100% - 90px)">
                                    <el-date-picker
                                            v-model="start_date"
                                            type="datetime" 
                                            format="yyyy-MM-dd HH:mm"
                                            value-format="yyyy-MM-dd HH:mm" 
                                            style="width:47%"
                                            placeholder="选择日期"
                                            @change="chooseTimeRange0"
                                    >
                                    </el-date-picker><span style="display: inline-block;width: 6%;text-align: center">至
                                            </span><el-date-picker
                                        v-model="end_date"
                                        type="datetime" 
                                        format="yyyy-MM-dd HH:mm"
                                        value-format="yyyy-MM-dd HH:mm" 
                                        placeholder="选择日期"
                                        style="width:47%"
                                        @change="chooseTimeRange2"
                                >
                                </el-date-picker>
                                </div>
                            </el-col>
                        </el-row>
                    </el-form>
                    <el-row style="margin-top:80px;border-bottom: 2px dotted rgb(231, 234, 236);padding-bottom: 20px;">
                        <el-button type="primary" size="small" @click.stop="handleQueryClick">查询</el-button>
                        <el-button type="danger" size="small" @click.stop="handleResetClick">重置</el-button>
                    </el-row>

                    <div style="margin-bottom: 20px">
                        <el-table
                                :header-cell-style="{'color':'black','font-size':'15px'}"
                                :data="taskList"
                                border
                                style="width: 100%;margin-top: 20px"
                                stripe>
                            <el-table-column
                                    fixed
                                    type="selection"
                                    width="55">
                            </el-table-column>
                            <el-table-column
                                    min-width="300"
                                    prop="task_name"
                                    sortable
                                    label="任务名称"
                            >
                            </el-table-column>
                            <el-table-column
                                    prop="reference_obj"
                                    sortable
                                    label="采集对象"
                                    width="220">
                                <template slot-scope="scope">
                                    <span v-for="item in scope.row.reference_obj" v-if="item == 'HCP'" style="text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 2px; ">
                                            HCP
                                    </span>
                                    <span v-for="item in scope.row.reference_obj" v-if="item == 'INSTITUTION'" style="text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 2px; ">
                                            机构
                                    </span>
                                    <span v-for="item in scope.row.reference_obj" v-if="item == 'RETAILSTORE'" style="text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 2px; ">
                                            门店
                                    </span>
                                    <span v-for="item in scope.row.reference_obj" v-if="item == 'DISTRIBUTOR'" style="text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 2px; ">
                                            经销商
                                    </span>
                                    <span v-for="item in scope.row.reference_obj" v-if="item == 'CUSTOMTABLE'" style="text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 2px; ">
                                            自定义表格
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    width="130"
                                    prop="field_num"
                                    sortable
                                    label="采集字段数"
                            >
                            </el-table-column>
                            <!-- <el-table-column
                                    width="140"
                                    prop="completed_num"
                                    sortable
                                    label="已采集记录数"
                            >
                            </el-table-column> -->
                            <el-table-column
                                    width="150"
                                    prop="start_date"
                                    sortable
                                    label="开始日期">

                            </el-table-column>
                            <el-table-column
                                    width="150"
                                    prop="end_date"
                                    label="结束日期"
                                    sortable
                            >

                            </el-table-column>
                            <el-table-column
                                    label-class-name="collectionHome_table_cell"
                                    fixed="right" label="操作"
                                    width="80"
                                    style="color: #3b99f7"
                            >
                                <template slot-scope="scope">
                                    <el-button
                                            style="color: #fff;background: #FE904C;border:none;border-radius: 10%" size="small"
                                            @click="handleDetail(scope.row)">详情
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <pagination  :page="page" @changePage="changePageClick"></pagination>
                    </div>
                </div>

            </div>
        </el-container>


    </div>
</template>

<script>
    import http from '../../APIService/http'
    import pagination from '../../components/pagination'

    import { Message } from "element-ui";
    import moment from 'moment'


    export default {
        name: "customCollect",
        data() {
            return {
                channelCheckList:[],
                searchForm:{},
                addTaskDetails:false,
                collectObject:[
                    {
                        id:'HCP',
                        value:'HCP'
                    },{
                        id:'INSTITUTION',
                        value:'机构'
                    },{
                        id:'RETAILSTORE',
                        value:'门店'
                    },{
                        id:'DISTRIBUTOR',
                        value:'经销商'
                    },,{
                        id:'CUSTOMTABLE',
                        value:'自定义表格'
                    },
                ],
                addTaskForm:{
                    task_name:'',
                    reference_obj:[],
                    start_date:'',
                    end_date:'',
                    comments:'',
                    territory_id:[]

                },
                territoryList:[],
                task_name:'',
                start_date:'',
                end_date:'',
                taskList:[],
                page:{
                    current: 1,
                    size: 5,
                    total: 0
                },
                clientObj:{},

            }
        },
        components: {
            pagination,
        },
        methods: {
            handleQueryClick(){
                this.page= {
                    current: 1,
                    size: 5,
                    total: 0
                }
                this.getCollectTask()
            },
            handleResetClick(){
                this.task_name=''
                this.start_date=''
                this.end_date=''
                this.channelCheckList = []
            },
            handleAddClick(){
                this.addTaskForm={
                    task_name:'',
                    reference_obj:[],
                    start_date:'',
                    end_date:'',
                    comments:''
                }
                this.addTaskDetails = true
            },
            add(){
                this.$refs["ruleForm"].validate(valid=>{
                    if(!valid){
                        return false
                    }else{
                        this.addTask()
                    }
                })
            },
            // getTerritoryList(){
            //     let loading = this.$loading({
            //         lock: true,
            //         text: '拼命加载中',
            //         spinner: 'el-icon-loading',
            //         background: 'rgba(0, 0, 0, 0.7)'
            //     });
            //     try{
            //         let user = this.$store.getters.getUser
            //         let data={
            //             tenant_id:user.tenant_id,
            //             user_id:user.user_id,
            //         }
            //         http.post('/wapi/Collect/getTerritoryList',data).then(res=>{
            //             if(res.success == true){
            //                 console.log(res.data)
            //                 this.territoryList = res.data
            //                 localStorage.setItem('territoryList',JSON.stringify(this.territoryList))
            //
            //                 loading.close()
            //             }
            //
            //         })
            //     }catch (e) {
            //         loading.close()
            //     }
            //
            // },
            addTask(){
                let user = this.$store.getters.getUser
                let data ={
                    tenant_id:user.tenant_id,
                    user_id:user.user_id,
                    task_name:this.addTaskForm.task_name,
                    reference_obj:this.addTaskForm.reference_obj,
                    start_date:this.addTaskForm.start_date,
                    end_date:this.addTaskForm.end_date,
                    comments:this.addTaskForm.comments,
                    territory_id:this.addTaskForm.territory_id
                }
                http.post('/wapi/Collect/addCollectTask',data).then(res=>{
                    if(res.success == true){
                        this.addTaskDetails = false
                        Message({
                            type:'success',
                            message:'保存成功'
                        })
                        this.getCollectTask()

                    }

                })

            },
            close(){
                this.$refs.ruleForm.resetFields();
                this.addTaskDetails = false
            },
            chooseTimeRange0(t){
                let time1 = moment(t).valueOf()
                let time2 = moment(this.addTaskForm.end_date).valueOf()
                if (time1>=time2){
                    this.$message({
                        type:"warning",
                        message:"结束日期应晚于开始日期"
                    })
                    this.addTaskForm.end_date = ''
                }

            },
            chooseTimeRange2(t){

                let time1 = moment(t).valueOf()
                let time2 = moment(this.addTaskForm.start_date).valueOf()


                if (time1<=time2){
                    this.$message({
                        type:"warning",
                        message:"结束日期应晚于开始日期"
                    })
                    this.addTaskForm.end_date = ''
                }
            },

            async getCollectTask() {
                let loading1 = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let data = {
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        user_id:this.$store.getters.getUser.user_id,
                        reference_obj : this.channelCheckList,
                        task_name:this.task_name,
                        start_date:this.start_date,
                        limit: this.page.size,
                        offset: this.page.current - 1,
                        end_date:this.end_date
                    }
                    await http.post('/crm/web/collection/getCollectionTaskList', data).then(res => {
                        debugger
                        if (res.success) {
                            this.taskList = res.data.result
                            this.taskList.forEach(item=>{
                                item.start_date =item.end_date.length>10? moment(item.start_date).format('YYYY年MM月DD日 HH:mm'): moment(item.start_date).format('YYYY年MM月DD日')
                                item.end_date =item.end_date.length>10? moment(item.end_date).format('YYYY年MM月DD日 HH:mm'): moment(item.end_date).format('YYYY年MM月DD日')
                            })
                            this.page.total=parseInt(res.data.arrayCount)
                            loading1.close()

                        } else {
                            Message.error(res.message);
                        }
                    })
                } catch (e) {
                    loading1.close()
                }

            },
            // 改变页码信息
            changePageClick(page, size) {
                if (page) {
                    this.page.current = page
                }
                if (size) {
                    this.page.size = size
                }
                this.getCollectTask()
            },
            handleDetail(row){

                this.$router.push({name:'resultCustomCollectInfo',params:row})
                localStorage.setItem('resultCustomCollectInfo',JSON.stringify(row))
            },



        },
        created() {
            this.getCollectTask()
            this.clientObj=this.$store.getters.getClient
            console.log(this.clientObj )

        },
        mounted(){

        },
        updated() {
        },
        beforeDestroy() {

        },
        computed: {

        },
        watch:{

        }
    }
</script>
<style lang="scss" module>
    .container {
        background: white;
        height: 100%;
        overflow: auto;
        .left {
            font-size: 18px;
            font-weight: bold;
            color: #000000;
            float: left;
            position: absolute;
            z-index:1;
            .type {
                em {
                    color: #d98f2f;
                    font-size: 14px;
                    font-weight: bold;
                }
            }

            .first {
                color: #555555;
                font-size: 20px;
            }
            .font {
                margin-left: 20px;
                font-size: 14px;
                color: #555555;
            }
        }
        .right {
            margin-top: -20px;
            width: 100%;
            .header {
                width: 100%;
                padding-bottom: 6px;
                border-bottom: 2px dotted #e7eaec;

            }
            .body {
                overflow: auto;

            }
        }

        .noData {

        }
    }
</style>
<style scoped>
    .el-container{
        height: 100%;
        padding: 20px;
        background: white;
    }
    #collectionHome {
        width: 100%;
        background: white;
        position: relative;
    }
    #collectionHome >>>.el-dialog__header{
        padding-top:0
    }
    #collectionHome >>> .el-form-item__label{
        font-size:14px;
        color: black;
        font-weight: bold;
    }
    #collectionHome >>>.el-tag.el-tag--info{
        background: #FF9901;
        color: #FFFFFF;
        border: none;
    }
    #collectionHome >>>.el-tag.el-tag--info .el-tag__close{
        display: none;
    }
    #collectionHome >>> .collectionHome_table_cell{
        color: #2b92fa !important;
    }


</style>




// WEBPACK FOOTER //
// src/pages/customCollect/luoshi_home.vue